import React, { useRef } from "react";
import emailjs from '@emailjs/browser';
import ReturnImage from "../functions/image";

const Form = () => {

    const form = useRef();

    function formSend(event) {
        event.preventDefault();
        console.log("edeffrf");

        let formValid = true;
        let mailMessage = '';

        const form = document.forms.contact;
        // console.log(form.elements);

        let usableForm = Array.from(form.elements);
        usableForm.pop();

        usableForm.forEach(field => {
            // console.log(field);
            mailMessage += `${field.name} : ${field.value}`;
        });

        console.log(mailMessage);



        const formData = new FormData(event.target);

  fetch("/", {
    method: "POST",
    body: formData,
  })
    .then(() => alert("Formulaire envoyé avec succès !"))
    .catch((error) => alert("Erreur d’envoi : " + error));
    }

    return (
        <div className="container form-parent pt-4 pb-4 pt-lg-5 pb-lg-5" id="contact">
            <h2 className="text-white text-center">N'hésitez pas à me contacter !</h2>
            <form 
             className="row form-wrapper p-4"
             ref={form} 
             onSubmit={(e) => formSend(e)} 
             name="contact" 
             method="POST" 
             netlify
             data-netlify="true"
             netlify-honeypot="bot-field">
                <div className="form-container col-12 col-sm-6 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <input className="form-controller" type="text" name="name" id="name" required />
                    <label className="form-label" for="name">Votre nom : *</label>
                </div>
                <div className="form-container col-12 col-sm-6 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <input className="form-controller" type="text" name="forename" id="forename" required />
                    <label className="form-label" for="forename">Votre prénom : *</label>
                </div>
                <div className="form-container col-12 col-sm-6 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <input className="form-controller" type="email" name="email" id="email" required />
                    <label className="form-label" for="email">Votre adresse e-mail : *</label>
                </div>
                <div className="form-container col-12 col-sm-6 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <input className="form-controller" type="tel" name="phone" id="phone" required />
                    <label className="form-label" for="phone">Votre téléphone : *</label>
                </div>
                <div className="form-container col-12 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <input className="form-controller" type="text" name="subject" id="subject" required />
                    <label className="form-label" for="subject">A quel sujet ? : *</label>
                </div>
                <div className="form-container col-12 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <textarea className="form-controller" name="message" id="message" required />
                    <label className="form-label" for="message">Avez-vous un message ? *</label>
                </div>
                <div className="form-container col-12 mt-1 mb-3 mt-sm-2 mb-sm-2">
                    <div className="d-inline-flex align-items-start">
                        <label for="rgpd">
                            <input className="form-controller" type="checkbox" name="rgpd" required />
                            <span className="text-white rgpd-label">J’accepte que les données de ce formulaire soient utilisées à des fins commerciales</span>
                        </label>
                    </div>
                </div>
                <div className="form-container col-12 mt-1 mt-sm-1">
                    <input className="button btn btn-primary form-validation mt-2" type="submit" name="ok" value="Envoyer" />
                </div>
                <input type="hidden" name="form-name" value="contact" />
                <input type="hidden" name="bot-field" />
            </form>
            <ReturnImage
             imageName="contactez-mek"
             classname="form-image"
             alt="Contactez Mustafa Ekiz pour une demande de site web"
             viewport={100} />
        </div>
    );
};

export default Form;